// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormTemplate_wrapper__1tNol","drawer":"FormTemplate_drawer__1MGa4"};